import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { lang } from "../lang";

const PostSuccess = () => {
  const [ln,setLn] = useState('en')
    const navigate = useNavigate();
    useEffect(()=>{
      if(localStorage.getItem("language") != null){
        setLn(localStorage.getItem("language"))
      }
    },[])
    const navigateToSuccess = () =>{navigate('/vaccancy')}
  return (
    <div
      className="flex-center h-100"
      style={{ }}
    >
      <div className="py-3">
        <img  className="mt-5" src="./images/post-success.jpg" style={{height: "300px", width: "300px"}} alt="" />
        <p className="post-success-text mt-3">{lang && Object.keys(lang).length > 0 ? lang[ln]?.PostSuccessFulMessage["Vacancy Posted Successfully !"]:""}</p>

        <div className="space-between d-flex">
          {/* <button
            className="theme-btn-outline mt-5 btn-block"
            onClick={() => navigateToSuccess( )}
          >
            Edit Vacancy
          </button> */}

          <button
            className="theme-btn mt-5 btn-block mx-2"
            onClick={() => navigateToSuccess()}
          >
            {lang && Object.keys(lang).length > 0 ? lang[ln]?.YearMonth["My Vacancy"]:""}
          </button>
        </div>

        {/* <button
          className="theme-btn mt-5 btn-block"
          onClick={() => navigateToSuccess()}
        >
          Post Another Vacancy
        </button> */}
      </div>
    </div>
  );
};

export default PostSuccess;
